import React from 'react';
import { Box } from '@chakra-ui/react';
import TablaPromotoresCulturales from './TablaPromotoresCulturales';

const PromotoresCulturales: React.FC = () => {
  return (
    <Box px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <TablaPromotoresCulturales />
    </Box>
  );
};

export default PromotoresCulturales;
